import React, { useEffect, useState } from "react";
import Notification from "../../elements/notification/Notification";
import axios from "axios";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import PageSpinner from "../../elements/spinner/PageSpinner";
import { Alert } from "@material-ui/lab";
import { useHistory } from "react-router-dom";
import GoToBackButton from "../../elements/goToBack/GoToBack";
import { TextField } from "@material-ui/core";
import BlockchainUrlEditForm from "./BlockchainUrlEditForm";
import { useTranslation } from "react-i18next";

import { StyledContentWrapper } from "../../styles/styledMain";
import { StyledBlockLabel, StyledFormBlock, StyledFormGrid, StyledInputBlock } from "../../styles/styledTabsForm";
import { StyledFeeDetailsWrapper } from "../../fee/styledFee";

const BlockchainUrlDetailsContainer = ({ match }) => {
  const { t } = useTranslation("blockchainUrlPage");
  const [blockchainUrl, setBlockchainUrl] = useState();
  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get("/api/currency-settings/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setBlockchainUrl(response.data);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  }, []);

  if (!blockchainUrl) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (blockchainUrl.length === 0) {
    return <Alert severity="warning">{t("details.changeForm.emptyData")}</Alert>;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <StyledFeeDetailsWrapper>
          <GoToBackButton
            handler={() => {history.goBack();}}
            pt="20"
            pb="30"
          />
          <StyledFormGrid>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("details.changeForm.currency")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.currency")}
                  type="text"
                  value={blockchainUrl.currency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("details.changeForm.paymentSystem")}
              </StyledBlockLabel>
              <StyledInputBlock>
                <TextField
                  className="grid-form__input"
                  label={t("details.changeForm.paymentSystem")}
                  type="text"
                  value={blockchainUrl.currency.asset}
                  variant="filled"
                  InputProps={{
                    readOnly: true
                  }}
                />
              </StyledInputBlock>
              <div className="clear-column" />
            </StyledFormBlock>
            <StyledFormBlock>
              <StyledBlockLabel>
                {t("details.changeForm.link")}
              </StyledBlockLabel>
              <BlockchainUrlEditForm
                blockchainUrl={blockchainUrl}
                notification={notification}
                setNotification={setNotification}
              />
              <div className="clear-column" />
            </StyledFormBlock>
          </StyledFormGrid>
        </StyledFeeDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default BlockchainUrlDetailsContainer;